import { render, staticRenderFns } from "./addProfessional.vue?vue&type=template&id=625cb1ab&scoped=true&"
import script from "./addProfessional.vue?vue&type=script&lang=js&"
export * from "./addProfessional.vue?vue&type=script&lang=js&"
import style0 from "./addProfessional.vue?vue&type=style&index=0&id=625cb1ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cb1ab",
  null
  
)

export default component.exports